// src/components/activity-recommendations/activity-recommendations.tsx
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    referrerId\n    linkName\n    eventType\n    uisPrimeMessages {\n      schemaName\n      messageContent\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment ActivityFragment on Activity {\n    name\n    image {\n      description\n      url\n    }\n    features {\n      travelDistance {\n        label\n      }\n      volumePricing {\n        description\n      }\n    }\n    reviewSummary {\n      reviewCountMessage\n      reviewRatingMessage\n      reviewRatingAccessibilityText\n    }\n    leadTicket {\n      label\n      priceAccessibilityText\n      price {\n        leadFormatted\n        strikeOutFormatted\n      }\n      type\n    }\n    clickAction {\n      url\n      openInNewTab\n      clickAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n    }\n    clientSideAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment ActivityActionTileFragment on ActivityActionTile {\n    name\n    link\n    image {\n      description\n      url\n    }\n    primaryAction {\n      url\n      label\n      openInNewTab\n    }\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment ActivityTileFragment on ActivityTile {\n    ... on Activity {\n      ...ActivityFragment\n    }\n\n    ... on ActivityActionTile {\n      ...ActivityActionTileFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  query ActivityRecommendationsQuery(\n    $context: ContextInput!\n    $dateRange: ActivityDateRangeInput\n    $destination: ActivityDestinationInput\n    $pagination: PaginationInput!\n    $searchViewOptions: [ActivitySearchViewOptions!]\n    $activityGroupType: [ActivityGroupType!]\n    $travelerInfo: ActivityTravelerInfoInput\n  ) {\n    activitySearch(\n      context: $context\n      dateRange: $dateRange\n      destination: $destination\n      groupType: $activityGroupType\n      pagination: $pagination\n      searchViewOptions: $searchViewOptions\n      travelerInfo: $travelerInfo\n    ) {\n      activityGroups(types: $activityGroupType) {\n        name\n        activityTiles {\n          ...ActivityTileFragment\n        }\n        action {\n          label\n          url\n        }\n        navigationActions {\n          previous {\n            accessibility\n          }\n          next {\n            accessibility\n          }\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment ActivitiesByCategoriesResultActivitiesFragment on Activity {\n    id\n    name\n    clickAction {\n      accessibilityText\n      url\n      openInNewTab\n      label\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    reviewSummary {\n      score {\n        formatted\n        raw\n      }\n      total\n      reviewCountMessage\n      reviewRatingMessage\n      reviewRatingAccessibilityText\n    }\n    leadTicket {\n      label\n      type\n      code\n      price {\n        lead {\n          currencyInfo {\n            name\n            code\n          }\n        }\n        leadFormatted\n        leadAmount\n        strikeOutFormatted\n        strikeOutAmount\n      }\n      priceAccessibilityText\n    }\n    image {\n      description\n      url\n    }\n    duration {\n      icon {\n        description\n        id\n        size\n        withBackground\n        title\n      }\n      formatted\n    }\n    features {\n      freeCancellation {\n        type\n        formatted\n      }\n    }\n  }\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment ActivitiesByCategoriesResultCategoriesFragment on ActivityGroup {\n    name\n    action {\n      accessibilityText\n      label\n      url\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n    viewType\n    activityTiles {\n      ...ActivitiesByCategoriesResultActivitiesFragment\n    }\n  }\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  query ActivitiesByCategoriesQuery($context: ContextInput!, $dateRange: ActivityDateRangeInput, $destination: ActivityDestinationInput) {\n    activityModules(context: $context, dateRange: $dateRange, destination: $destination) {\n      activitiesByCategories {\n        action {\n          accessibilityText\n          label\n          url\n          analytics {\n            linkName\n            referrerId\n          }\n        }\n        groups {\n          ...ActivitiesByCategoriesResultCategoriesFragment\n        }\n        seoStructuredData\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment PoiDetailsFragment on ActivityPoiTile {\n    title\n    detailsLink {\n      text\n      accessibilityText\n      clickAction {\n        __typename\n        ... on ActivityLinkClickAction {\n          anchorTagUrl\n          accessibilityText\n        }\n        analytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n    description\n    medias {\n      __typename\n      ... on Image {\n        url\n        description\n      }\n    }\n  }\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment ActivitiesByPoiResultFragment on ActivityPoiGroup {\n    poiTile {\n      ...PoiDetailsFragment\n    }\n    activitiesGroup {\n      ...ActivitiesByCategoriesResultCategoriesFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  query ActivitiesByPoiQuery($context: ContextInput!, $dateRange: ActivityDateRangeInput, $destination: ActivityDestinationInput) {\n    activityModules(context: $context, dateRange: $dateRange, destination: $destination) {\n      activityItemsByPoi {\n        groups {\n          ...ActivitiesByPoiResultFragment\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
import React4 from "react";
import { gql as gql5, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useExperiment as useExperiment3 } from "@shared-ui/experiment-context";
import { UitkCarousel } from "uitk-react-carousel";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3 } from "uitk-react-text";
// src/__generated__/types.ts
var ActivitySearchViewOptions = /* @__PURE__ */function (ActivitySearchViewOptions2) {
  ActivitySearchViewOptions2["DISTANCE_FROM_HOTEL_TO_ACTIVITY"] = "DISTANCE_FROM_HOTEL_TO_ACTIVITY";
  ActivitySearchViewOptions2["FILTER_NESTED_CATEGORIES"] = "FILTER_NESTED_CATEGORIES";
  ActivitySearchViewOptions2["NEARBY_ACTIVITIES"] = "NEARBY_ACTIVITIES";
  ActivitySearchViewOptions2["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
  ActivitySearchViewOptions2["SHOW_GT_BANNER"] = "SHOW_GT_BANNER";
  ActivitySearchViewOptions2["THIRD_PARTY_REVIEWS"] = "THIRD_PARTY_REVIEWS";
  ActivitySearchViewOptions2["TRAVEL_DISTANCE_FROM_HOTEL"] = "TRAVEL_DISTANCE_FROM_HOTEL";
  return ActivitySearchViewOptions2;
}(ActivitySearchViewOptions || {});
// src/components/activity-recommendations/__private/__fragments/activity.tsx
import React from "react";
import { gql as gql2 } from "@apollo/client";
import { IntersectionTracker, useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { useExperiment } from "@shared-ui/experiment-context";
import { UitkCard, UitkCardContentSection, UitkCardLink } from "uitk-react-cards";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkPriceLockup } from "uitk-react-price-lockup";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading, UitkText } from "uitk-react-text";
// src/util/analytics.ts
function sendTracking(analytics, track) {
  track(analytics.referrerId, analytics.linkName, void 0, getMicroMessages(analytics.uisPrimeMessages));
}
function getMicroMessages(uisPrimeMessages) {
  var _uisPrimeMessages;
  return (_uisPrimeMessages = uisPrimeMessages) === null || _uisPrimeMessages === void 0 ? void 0 : _uisPrimeMessages.map(function (uisPrimeMessage) {
    return {
      messageContent: JSON.parse(uisPrimeMessage.messageContent),
      schemaName: uisPrimeMessage.schemaName
    };
  });
}
// src/util/fragments/client-side-analytics-fragments.ts
import { gql } from "@apollo/client";
var ClientSideAnalyticsFragment = gql(_templateObject());
// src/components/activity-recommendations/__private/__fragments/activity.tsx
var __Fragment = gql2(_templateObject1(), ClientSideAnalyticsFragment);
var Activity = function (_param) {
  var className = _param.className,
    data = _param.data,
    attributes = _object_without_properties(_param, ["className", "data"]);
  var _clickAction, _clientSideAnalytics, _clientSideAnalytics1, _clientSideAnalytics2, _image, _image1, _features_volumePricing;
  var name = data.name,
    image = data.image,
    features = data.features,
    clickAction = data.clickAction,
    leadTicket = data.leadTicket,
    reviewSummary = data.reviewSummary,
    clientSideAnalytics = data.clientSideAnalytics;
  var _useExperiment = useExperiment("SRP_and_PDP_White_canvas"),
    whiteCanvasExperiment = _useExperiment.exposure;
  var trackClick = useClickTracker();
  var onClickCapture = React.useCallback(function () {
    var _clickAction;
    if ((_clickAction = clickAction) === null || _clickAction === void 0 ? void 0 : _clickAction.clickAnalytics) {
      sendTracking(clickAction.clickAnalytics, trackClick);
    }
  }, [(_clickAction = clickAction) === null || _clickAction === void 0 ? void 0 : _clickAction.clickAnalytics, trackClick]);
  var _clientSideAnalytics_referrerId, _clientSideAnalytics_linkName, _image_url, _image_description, _leadTicket_label, _features_volumePricing_description, _leadTicket_price_strikeOutFormatted, _leadTicket_priceAccessibilityText;
  return /* @__PURE__ */React.createElement(UitkLayoutFlex, _object_spread({
    className: className,
    tag: "li"
  }, attributes), /* @__PURE__ */React.createElement(UitkLayoutFlexItem, {
    grow: 1
  }, /* @__PURE__ */React.createElement(IntersectionTracker, {
    trackOnce: true,
    referrerId: (_clientSideAnalytics_referrerId = (_clientSideAnalytics = clientSideAnalytics) === null || _clientSideAnalytics === void 0 ? void 0 : _clientSideAnalytics.referrerId) !== null && _clientSideAnalytics_referrerId !== void 0 ? _clientSideAnalytics_referrerId : "",
    linkName: (_clientSideAnalytics_linkName = (_clientSideAnalytics1 = clientSideAnalytics) === null || _clientSideAnalytics1 === void 0 ? void 0 : _clientSideAnalytics1.linkName) !== null && _clientSideAnalytics_linkName !== void 0 ? _clientSideAnalytics_linkName : "",
    additionalUisPrimeMicroMessages: ((_clientSideAnalytics2 = clientSideAnalytics) === null || _clientSideAnalytics2 === void 0 ? void 0 : _clientSideAnalytics2.uisPrimeMessages) ? getMicroMessages(clientSideAnalytics.uisPrimeMessages) : void 0
  }, /* @__PURE__ */React.createElement(UitkCard, {
    border: whiteCanvasExperiment.bucket === 1
  }, /* @__PURE__ */React.createElement(UitkLayoutFlex, {
    direction: "column",
    blockSize: "full_size",
    justifyContent: "space-between"
  }, /* @__PURE__ */React.createElement(UitkLayoutPosition, {
    type: "relative"
  }, /* @__PURE__ */React.createElement(UitkFigure, {
    ratio: UitkFigureAspectRatioType.R16_9
  }, /* @__PURE__ */React.createElement(UitkImage, {
    placeholderImage: true,
    src: (_image_url = (_image = image) === null || _image === void 0 ? void 0 : _image.url) !== null && _image_url !== void 0 ? _image_url : void 0,
    alt: (_image_description = (_image1 = image) === null || _image1 === void 0 ? void 0 : _image1.description) !== null && _image_description !== void 0 ? _image_description : void 0,
    lazyLoading: "lazy"
  }))), /* @__PURE__ */React.createElement(UitkLayoutFlexItem, {
    grow: 1
  }, /* @__PURE__ */React.createElement(UitkCardContentSection, null, /* @__PURE__ */React.createElement(UitkHeading, {
    tag: "h4",
    size: 7
  }, name), /* @__PURE__ */React.createElement("div", null, features.travelDistance && /* @__PURE__ */React.createElement(UitkSpacing, {
    margin: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React.createElement(UitkText, {
    align: "left",
    size: 200
  }, features.travelDistance.label)), reviewSummary && /* @__PURE__ */React.createElement(UitkSpacing, {
    margin: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React.createElement(UitkLayoutFlex, null, /* @__PURE__ */React.createElement("span", {
    className: "is-visually-hidden"
  }, reviewSummary.reviewRatingAccessibilityText), /* @__PURE__ */React.createElement(UitkText, {
    weight: "bold",
    size: 300,
    "aria-hidden": true
  }, reviewSummary.reviewRatingMessage), /* @__PURE__ */React.createElement(UitkSpacing, {
    margin: {
      inlinestart: "one"
    }
  }, /* @__PURE__ */React.createElement(UitkText, {
    size: 300,
    "aria-hidden": true
  }, reviewSummary.reviewCountMessage))))))), leadTicket.price && /* @__PURE__ */React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React.createElement(UitkCardContentSection, null, /* @__PURE__ */React.createElement(UitkPriceLockup, {
    lockupPrice: leadTicket.price.leadFormatted,
    priceSubtextFirst: (_leadTicket_label = leadTicket.label) !== null && _leadTicket_label !== void 0 ? _leadTicket_label : void 0,
    priceSubtextStandard: (_features_volumePricing_description = (_features_volumePricing = features.volumePricing) === null || _features_volumePricing === void 0 ? void 0 : _features_volumePricing.description) !== null && _features_volumePricing_description !== void 0 ? _features_volumePricing_description : void 0,
    strikeThroughPrice: (_leadTicket_price_strikeOutFormatted = leadTicket.price.strikeOutFormatted) !== null && _leadTicket_price_strikeOutFormatted !== void 0 ? _leadTicket_price_strikeOutFormatted : void 0,
    a11yPrice: (_leadTicket_priceAccessibilityText = leadTicket.priceAccessibilityText) !== null && _leadTicket_priceAccessibilityText !== void 0 ? _leadTicket_priceAccessibilityText : ""
  }))), clickAction && /* @__PURE__ */React.createElement(UitkCardLink, null, /* @__PURE__ */React.createElement("a", {
    href: clickAction.url,
    rel: "noopener noreferrer",
    onClickCapture: onClickCapture,
    target: clickAction.openInNewTab ? "_blank" : "_self"
  }, name)))))));
};
Activity.displayName = "ActivityFragment";
Activity.fragment = __Fragment;
// src/components/activity-recommendations/__private/__fragments/activity-action-tile.tsx
import React2 from "react";
import { gql as gql3 } from "@apollo/client";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { UitkCard as UitkCard2, UitkCardActionArea, UitkCardContentSection as UitkCardContentSection2 } from "uitk-react-cards";
import { UitkFigure as UitkFigure2, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage as UitkImage2 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
var __Fragment2 = gql3(_templateObject2());
var ActivityActionTile = function (_param) {
  var className = _param.className,
    data = _param.data,
    attributes = _object_without_properties(_param, ["className", "data"]);
  var _image, _image1, _primaryAction;
  var name = data.name,
    image = data.image,
    primaryAction = data.primaryAction;
  var _useExperiment2 = useExperiment2("SRP_and_PDP_White_canvas"),
    whiteCanvasExperiment = _useExperiment2.exposure;
  var _image_url, _image_description;
  return /* @__PURE__ */React2.createElement(UitkLayoutFlex2, _object_spread({
    className: className,
    tag: "li"
  }, attributes), /* @__PURE__ */React2.createElement(UitkCard2, {
    border: whiteCanvasExperiment.bucket === 1
  }, /* @__PURE__ */React2.createElement(UitkLayoutFlex2, {
    direction: "column"
  }, /* @__PURE__ */React2.createElement(UitkLayoutFlexItem2, {
    grow: 0
  }, /* @__PURE__ */React2.createElement(UitkFigure2, {
    ratio: UitkFigureAspectRatioType2.R16_9
  }, /* @__PURE__ */React2.createElement(UitkImage2, {
    placeholderImage: true,
    src: (_image_url = (_image = image) === null || _image === void 0 ? void 0 : _image.url) !== null && _image_url !== void 0 ? _image_url : void 0,
    alt: (_image_description = (_image1 = image) === null || _image1 === void 0 ? void 0 : _image1.description) !== null && _image_description !== void 0 ? _image_description : void 0
  }))), /* @__PURE__ */React2.createElement(UitkLayoutFlexItem2, {
    grow: 1
  }, /* @__PURE__ */React2.createElement(UitkCardContentSection2, null, /* @__PURE__ */React2.createElement(UitkHeading2, {
    tag: "h4",
    size: 7
  }, name))), /* @__PURE__ */React2.createElement(UitkLayoutFlexItem2, {
    grow: 0
  }, /* @__PURE__ */React2.createElement(UitkCardActionArea, null, /* @__PURE__ */React2.createElement("a", {
    href: primaryAction.url,
    rel: "noopener noreferrer",
    target: ((_primaryAction = primaryAction) === null || _primaryAction === void 0 ? void 0 : _primaryAction.openInNewTab) ? "_blank" : "_self"
  }, primaryAction.label))))));
};
ActivityActionTile.displayName = "ActivityActionTile";
ActivityActionTile.fragment = __Fragment2;
// src/components/activity-recommendations/__private/__fragments/activity-tile.tsx
import React3 from "react";
import { gql as gql4 } from "@apollo/client";
var __Fragment3 = gql4(_templateObject3(), Activity.fragment, ActivityActionTile.fragment);
var ActivityTile = function (_param) {
  var className = _param.className,
    data = _param.data,
    attributes = _object_without_properties(_param, ["className", "data"]);
  switch (data.__typename) {
    case "Activity":
      return /* @__PURE__ */React3.createElement(Activity, _object_spread({
        className: className,
        data: data
      }, attributes));
    case "ActivityActionTile":
      return /* @__PURE__ */React3.createElement(ActivityActionTile, _object_spread({
        className: className,
        data: data
      }, attributes));
    default:
      return null;
  }
};
ActivityTile.displayName = "ActivityTile";
ActivityTile.fragment = __Fragment3;
// src/components/activity-recommendations/activity-recommendations.tsx
var __Query = gql5(_templateObject4(), ActivityTile.fragment);
var carouselMargin = {
  block: "three"
};
var ActivityRecommendations = function (props) {
  var _inputs, _data, _activityGroups;
  var inputs = props.inputs,
    skipSsr = props.skipSsr;
  var context = useBexApi().context;
  var _useExperiment3 = useExperiment3("SRP_and_PDP_White_canvas"),
    whiteCanvasExperiment = _useExperiment3.exposure;
  var isWhiteCanvas = whiteCanvasExperiment.bucket === 1;
  var _inputs_activityGroupType;
  var activityGroupTypeOrDefault = (_inputs_activityGroupType = (_inputs = inputs) === null || _inputs === void 0 ? void 0 : _inputs.activityGroupType) !== null && _inputs_activityGroupType !== void 0 ? _inputs_activityGroupType : ["XSELL_RECOMMENDATIONS" /* XSELL_RECOMMENDATIONS */];
  var variables = _object_spread_props(_object_spread({}, inputs), {
    activityGroupType: activityGroupTypeOrDefault,
    context: context,
    pagination: {
      startingIndex: 0,
      size: 6
    }
  });
  var _useQuery = useQuery(__Query, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  var activityGroups = (_data = data) === null || _data === void 0 ? void 0 : _data.activitySearch.activityGroups;
  if (loading || error || !((_activityGroups = activityGroups) === null || _activityGroups === void 0 ? void 0 : _activityGroups.length)) {
    return null;
  }
  var _activityGroup_navigationActions_next_accessibility, _activityGroup_navigationActions_previous_accessibility;
  return /* @__PURE__ */React4.createElement(UitkSpacing2, {
    border: isWhiteCanvas ? ["blockstart", "blockend"] : [],
    padding: isWhiteCanvas ? {
      block: "six"
    } : {}
  }, /* @__PURE__ */React4.createElement("div", null, activityGroups.map(function (activityGroup, carouselIndex) {
    var _activityGroup_navigationActions, _activityGroup_navigationActions1;
    return /* @__PURE__ */React4.createElement(React4.Fragment, {
      key: "activity-group-".concat(carouselIndex)
    }, activityGroup.name && /* @__PURE__ */React4.createElement(UitkHeading3, {
      tag: "h3",
      size: 5
    }, activityGroup.name), /* @__PURE__ */React4.createElement(UitkSpacing2, {
      margin: carouselMargin
    }, /* @__PURE__ */React4.createElement(UitkCarousel, {
      buttonText: {
        nextButton: (_activityGroup_navigationActions_next_accessibility = (_activityGroup_navigationActions = activityGroup.navigationActions) === null || _activityGroup_navigationActions === void 0 ? void 0 : _activityGroup_navigationActions.next.accessibility) !== null && _activityGroup_navigationActions_next_accessibility !== void 0 ? _activityGroup_navigationActions_next_accessibility : "",
        prevButton: (_activityGroup_navigationActions_previous_accessibility = (_activityGroup_navigationActions1 = activityGroup.navigationActions) === null || _activityGroup_navigationActions1 === void 0 ? void 0 : _activityGroup_navigationActions1.previous.accessibility) !== null && _activityGroup_navigationActions_previous_accessibility !== void 0 ? _activityGroup_navigationActions_previous_accessibility : ""
      },
      pageBy: 1,
      peek: true,
      itemsVisible: {
        lg: 4,
        md: 2,
        sm: 1
      },
      wrapItems: true,
      itemsMaxHeight: true
    }, activityGroup.activityTiles.map(function (activityTile, index) {
      return /* @__PURE__ */React4.createElement(ActivityTile, {
        key: "activity-tile-".concat(index),
        data: activityTile
      });
    }))));
  })));
};
ActivityRecommendations.displayName = "sharedui-ActivityRecommendations";
// src/components/activities-by-categories/activities-by-categories.tsx
import React12 from "react";
import { gql as gql8, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { UitkSecondaryButton as UitkSecondaryButton2 } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex7 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading8 } from "uitk-react-text";
// src/components/activities-by-categories/__private/__fragments/activities-by-categories-result-categories.tsx
import React11 from "react";
import { gql as gql7 } from "@apollo/client";
// src/components/activities-by-categories/activities-by-categories-category-carousel.tsx
import React9 from "react";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { UitkCarousel as UitkCarousel2 } from "uitk-react-carousel";
import { UitkLayoutColumns } from "uitk-react-layout-columns";
import { UitkLink } from "uitk-react-link";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading6 } from "uitk-react-text";
// src/components/activities-by-categories/__private/__fragments/activities-by-categories-result-activities.tsx
import React8 from "react";
import { gql as gql6 } from "@apollo/client";
// src/components/activities-by-categories/activities-by-categories-activity-carousel.tsx
import React6 from "react";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard3, UitkCardContentSection as UitkCardContentSection3, UitkCardLink as UitkCardLink2 } from "uitk-react-cards";
import { UitkFigure as UitkFigure3, UitkFigureAspectRatioType as UitkFigureAspectRatioType3, UitkImage as UitkImage3 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkLayoutPosition as UitkLayoutPosition2 } from "uitk-react-layout-position";
import { UitkPriceLockup as UitkPriceLockup2 } from "uitk-react-price-lockup";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading4, UitkText as UitkText3 } from "uitk-react-text";
// src/util/pricing.ts
function getPriceDetails(activity) {
  var _activity_leadTicket_price, _activity_leadTicket_price1;
  var strikeOutFormattedPrice = (_activity_leadTicket_price = activity.leadTicket.price) === null || _activity_leadTicket_price === void 0 ? void 0 : _activity_leadTicket_price.strikeOutFormatted;
  var leadFormattedPrice = (_activity_leadTicket_price1 = activity.leadTicket.price) === null || _activity_leadTicket_price1 === void 0 ? void 0 : _activity_leadTicket_price1.leadFormatted;
  var leadPriceLabel = activity.leadTicket.label;
  var priceAccessibilityText = activity.leadTicket.priceAccessibilityText;
  return {
    strikeOutFormattedPrice: strikeOutFormattedPrice,
    leadPriceLabel: leadPriceLabel,
    leadFormattedPrice: leadFormattedPrice,
    priceAccessibilityText: priceAccessibilityText
  };
}
// src/components/activities-by-categories/activity-feature.tsx
import React5 from "react";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex3 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkText as UitkText2 } from "uitk-react-text";
var ActivityFeature = function (param) {
  var label = param.label,
    a11yLabel = param.a11yLabel,
    icon = param.icon;
  return /* @__PURE__ */React5.createElement(React5.Fragment, null, /* @__PURE__ */React5.createElement(UitkSpacing3, {
    margin: {
      block: "one"
    }
  }, /* @__PURE__ */React5.createElement(UitkLayoutFlex3, {
    alignItems: "center"
  }, icon && /* @__PURE__ */React5.createElement(UitkIcon, {
    name: icon.id,
    size: UitkIconSize.EXTRA_SMALL,
    id: icon.id,
    description: icon.description
  }), /* @__PURE__ */React5.createElement("span", null, a11yLabel && /* @__PURE__ */React5.createElement("span", {
    className: "is-visually-hidden"
  }, a11yLabel), /* @__PURE__ */React5.createElement("span", {
    "aria-hidden": Boolean(a11yLabel)
  }, /* @__PURE__ */React5.createElement(UitkText2, {
    size: 300
  }, label))))));
};
// src/components/activities-by-categories/activities-by-categories-activity-carousel.tsx
var ActivityCarouselItem = function (param) {
  var data = param.data;
  var _data_reviewSummary, _data_image, _data_image1, _data_duration_icon, _data_reviewSummary1, _data_features_freeCancellation, _data_clickAction;
  var _getPriceDetails = getPriceDetails(data),
    strikeOutFormattedPrice = _getPriceDetails.strikeOutFormattedPrice,
    leadPriceLabel = _getPriceDetails.leadPriceLabel,
    leadFormattedPrice = _getPriceDetails.leadFormattedPrice,
    priceAccessibilityText = _getPriceDetails.priceAccessibilityText;
  var reviewA11yLabel = (_data_reviewSummary = data.reviewSummary) === null || _data_reviewSummary === void 0 ? void 0 : _data_reviewSummary.reviewRatingAccessibilityText;
  var trackClick = useClickTracker2();
  return /* @__PURE__ */React6.createElement(UitkCard3, {
    "data-stid": "activity-carousel-tile-card"
  }, /* @__PURE__ */React6.createElement(UitkLayoutFlex4, null, /* @__PURE__ */React6.createElement(UitkLayoutFlexItem3, {
    minWidth: "half_width"
  }, /* @__PURE__ */React6.createElement(UitkLayoutPosition2, {
    type: "relative"
  }, /* @__PURE__ */React6.createElement(UitkFigure3, {
    className: "all-image-fit-cover",
    ratio: UitkFigureAspectRatioType3.R3_4
  }, /* @__PURE__ */React6.createElement(UitkImage3, {
    alt: (_data_image = data.image) === null || _data_image === void 0 ? void 0 : _data_image.description,
    src: (_data_image1 = data.image) === null || _data_image1 === void 0 ? void 0 : _data_image1.url
  })))), /* @__PURE__ */React6.createElement(UitkLayoutFlexItem3, {
    minWidth: "full_width"
  }, /* @__PURE__ */React6.createElement(UitkCardContentSection3, null, /* @__PURE__ */React6.createElement(UitkLayoutFlex4, {
    tag: "section",
    direction: "column",
    alignContent: "space-between",
    blockSize: "full_size"
  }, /* @__PURE__ */React6.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React6.createElement(UitkHeading4, {
    size: 6,
    overflow: "truncate-3-lines"
  }, data.name)), /* @__PURE__ */React6.createElement(UitkLayoutFlexItem3, {
    grow: 1
  }, /* @__PURE__ */React6.createElement(UitkLayoutFlex4, {
    wrap: "nowrap",
    tag: "section",
    direction: "row",
    "data-testid": "activity-spanned-tile-card-content",
    justifyContent: "space-between"
  }, /* @__PURE__ */React6.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React6.createElement(UitkLayoutFlex4, {
    wrap: "nowrap",
    tag: "section",
    direction: "column",
    justifyContent: "space-between"
  }, /* @__PURE__ */React6.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React6.createElement(UitkSpacing4, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React6.createElement(UitkLayoutFlex4, {
    wrap: "nowrap",
    tag: "section",
    direction: "column",
    justifyContent: "start"
  }, data.duration.formatted && /* @__PURE__ */React6.createElement(UitkSpacing4, {
    margin: {
      blockend: "one"
    }
  }, /* @__PURE__ */React6.createElement(UitkLayoutFlexItem3, {
    className: "uitk-type-200"
  }, /* @__PURE__ */React6.createElement(ActivityFeature, {
    label: data.duration.formatted,
    a11yLabel: ((_data_duration_icon = data.duration.icon) === null || _data_duration_icon === void 0 ? void 0 : _data_duration_icon.title) || "",
    icon: data.duration.icon
  }))), ((_data_reviewSummary1 = data.reviewSummary) === null || _data_reviewSummary1 === void 0 ? void 0 : _data_reviewSummary1.reviewRatingMessage) && /* @__PURE__ */React6.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React6.createElement(UitkLayoutFlex4, {
    alignItems: "center"
  }, /* @__PURE__ */React6.createElement("span", null, reviewA11yLabel && /* @__PURE__ */React6.createElement("span", {
    className: "is-visually-hidden"
  }, reviewA11yLabel), /* @__PURE__ */React6.createElement("span", {
    "aria-hidden": Boolean(reviewA11yLabel)
  }, /* @__PURE__ */React6.createElement(UitkSpacing4, {
    margin: {
      inlineend: "one"
    }
  }, /* @__PURE__ */React6.createElement(UitkText3, {
    size: 400,
    weight: "bold",
    theme: "emphasis"
  }, data.reviewSummary.reviewRatingMessage)), /* @__PURE__ */React6.createElement(UitkText3, {
    size: 300,
    theme: "default"
  }, data.reviewSummary.reviewCountMessage)))))))), data.features.freeCancellation && /* @__PURE__ */React6.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React6.createElement(UitkSpacing4, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React6.createElement(UitkLayoutFlex4, {
    wrap: "nowrap",
    tag: "section",
    direction: "column",
    justifyContent: "end"
  }, ((_data_features_freeCancellation = data.features.freeCancellation) === null || _data_features_freeCancellation === void 0 ? void 0 : _data_features_freeCancellation.type) === "FREE_CANCELLATION" /* FREE_CANCELLATION */ && /* @__PURE__ */React6.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React6.createElement(UitkText3, {
    size: 200,
    theme: "positive",
    "data-testid": "activity-free-cancellation"
  }, data.features.freeCancellation.formatted))))))), /* @__PURE__ */React6.createElement(UitkLayoutFlexItem3, {
    minWidth: "half_width"
  }, /* @__PURE__ */React6.createElement(UitkLayoutFlex4, {
    wrap: "nowrap",
    tag: "section",
    direction: "column",
    justifyContent: "end"
  }, /* @__PURE__ */React6.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React6.createElement(UitkPriceLockup2, {
    a11yPrice: priceAccessibilityText || "",
    lockupPrice: leadFormattedPrice || void 0,
    priceSubtextStandard: leadPriceLabel || void 0,
    strikeThroughPrice: strikeOutFormattedPrice || void 0
  })))))))))), ((_data_clickAction = data.clickAction) === null || _data_clickAction === void 0 ? void 0 : _data_clickAction.url) && /* @__PURE__ */React6.createElement(UitkCardLink2, null, /* @__PURE__ */React6.createElement("a", {
    href: data.clickAction.url,
    target: data.clickAction.openInNewTab ? "_blank" : "_self",
    rel: "noopener noreferrer",
    onClickCapture: function () {
      var _data_analytics, _data_analytics1;
      return trackClick(((_data_analytics = data.analytics) === null || _data_analytics === void 0 ? void 0 : _data_analytics.linkName) || "", ((_data_analytics1 = data.analytics) === null || _data_analytics1 === void 0 ? void 0 : _data_analytics1.referrerId) || "");
    },
    "data-stid": "activity-detail--carousel"
  }, data.name, /* @__PURE__ */React6.createElement("span", {
    className: "is-visually-hidden"
  }, data.clickAction.accessibilityText))));
};
// src/components/activities-by-categories/activities-by-categories-activity-grid.tsx
import React7 from "react";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard4, UitkCardContentSection as UitkCardContentSection4, UitkCardLink as UitkCardLink3 } from "uitk-react-cards";
import { UitkFigure as UitkFigure4, UitkFigureAspectRatioType as UitkFigureAspectRatioType4, UitkImage as UitkImage4 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition3 } from "uitk-react-layout-position";
import { UitkPriceLockup as UitkPriceLockup3, UitkPriceLockupAlign } from "uitk-react-price-lockup";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading5, UitkText as UitkText4 } from "uitk-react-text";
var ActivityGridItem = function (param) {
  var data = param.data;
  var _data_image, _data_image1, _data_reviewSummary, _data_features_freeCancellation, _data_features_freeCancellation1, _data_clickAction;
  var _getPriceDetails = getPriceDetails(data),
    strikeOutFormattedPrice = _getPriceDetails.strikeOutFormattedPrice,
    leadPriceLabel = _getPriceDetails.leadPriceLabel,
    leadFormattedPrice = _getPriceDetails.leadFormattedPrice,
    priceAccessibilityText = _getPriceDetails.priceAccessibilityText;
  var trackClick = useClickTracker3();
  return /* @__PURE__ */React7.createElement(UitkLayoutGridItem, null, /* @__PURE__ */React7.createElement(UitkCard4, {
    "data-stid": "activity-grid-tile-card"
  }, /* @__PURE__ */React7.createElement(UitkLayoutFlex5, {
    justifyContent: "space-between",
    direction: "column",
    blockSize: "full_size"
  }, /* @__PURE__ */React7.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */React7.createElement("section", null, /* @__PURE__ */React7.createElement(UitkLayoutPosition3, {
    type: "relative"
  }, /* @__PURE__ */React7.createElement(UitkFigure4, {
    ratio: UitkFigureAspectRatioType4.R21_9
  }, /* @__PURE__ */React7.createElement(UitkImage4, {
    alt: (_data_image = data.image) === null || _data_image === void 0 ? void 0 : _data_image.description,
    src: (_data_image1 = data.image) === null || _data_image1 === void 0 ? void 0 : _data_image1.url
  }))), /* @__PURE__ */React7.createElement(UitkCardContentSection4, null, /* @__PURE__ */React7.createElement(UitkLayoutFlex5, {
    tag: "section",
    direction: "column"
  }, /* @__PURE__ */React7.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */React7.createElement(UitkHeading5, {
    size: 6,
    overflow: "truncate-3-lines"
  }, data.name)), data.duration.formatted && /* @__PURE__ */React7.createElement(UitkSpacing5, {
    margin: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React7.createElement(UitkLayoutFlexItem4, {
    className: "uitk-type-200"
  }, /* @__PURE__ */React7.createElement(ActivityFeature, {
    label: data.duration.formatted,
    a11yLabel: data.duration.formatted,
    icon: data.duration.icon
  }))), ((_data_reviewSummary = data.reviewSummary) === null || _data_reviewSummary === void 0 ? void 0 : _data_reviewSummary.reviewRatingMessage) && /* @__PURE__ */React7.createElement(UitkSpacing5, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React7.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */React7.createElement(UitkLayoutFlex5, {
    alignItems: "center"
  }, /* @__PURE__ */React7.createElement(UitkSpacing5, {
    margin: {
      inlineend: "one"
    }
  }, /* @__PURE__ */React7.createElement(UitkText4, {
    size: 400,
    weight: "bold",
    theme: "emphasis"
  }, data.reviewSummary.reviewRatingMessage)), /* @__PURE__ */React7.createElement(UitkText4, {
    size: 300,
    theme: "default"
  }, data.reviewSummary.reviewCountMessage)))))))), /* @__PURE__ */React7.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */React7.createElement(UitkSpacing5, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React7.createElement(UitkCardContentSection4, null, /* @__PURE__ */React7.createElement(UitkLayoutFlex5, {
    tag: "section",
    direction: "column"
  }, ((_data_features_freeCancellation = data.features.freeCancellation) === null || _data_features_freeCancellation === void 0 ? void 0 : _data_features_freeCancellation.type) === "FREE_CANCELLATION" /* FREE_CANCELLATION */ && /* @__PURE__ */React7.createElement(UitkSpacing5, {
    margin: {
      blockend: "one"
    }
  }, /* @__PURE__ */React7.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */React7.createElement(UitkText4, {
    size: 200,
    theme: "positive",
    "data-testid": "activity-free-cancellation"
  }, (_data_features_freeCancellation1 = data.features.freeCancellation) === null || _data_features_freeCancellation1 === void 0 ? void 0 : _data_features_freeCancellation1.formatted))), /* @__PURE__ */React7.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */React7.createElement(UitkPriceLockup3, {
    align: UitkPriceLockupAlign.LEFT,
    a11yPrice: priceAccessibilityText || "",
    lockupPrice: leadFormattedPrice || void 0,
    priceSubtextStandard: leadPriceLabel || void 0,
    strikeThroughPrice: strikeOutFormattedPrice || void 0
  }))))))), ((_data_clickAction = data.clickAction) === null || _data_clickAction === void 0 ? void 0 : _data_clickAction.url) && /* @__PURE__ */React7.createElement(UitkCardLink3, null, /* @__PURE__ */React7.createElement("a", {
    href: data.clickAction.url,
    target: data.clickAction.openInNewTab ? "_blank" : "_self",
    rel: "noopener noreferrer",
    onClickCapture: function () {
      var _data_analytics, _data_analytics1;
      return trackClick(((_data_analytics = data.analytics) === null || _data_analytics === void 0 ? void 0 : _data_analytics.linkName) || "", ((_data_analytics1 = data.analytics) === null || _data_analytics1 === void 0 ? void 0 : _data_analytics1.referrerId) || "");
    },
    "data-stid": "activity-detail--grid"
  }, data.name, /* @__PURE__ */React7.createElement("span", {
    className: "is-visually-hidden"
  }, data.clickAction.accessibilityText)))));
};
// src/components/activities-by-categories/__private/__fragments/activities-by-categories-result-activities.tsx
var fragment = gql6(_templateObject5());
var ActivitiesByCategoriesResultActivities = function (props) {
  var data = props.data,
    view = props.view;
  if (!data) {
    return null;
  }
  return view === "grid" ? /* @__PURE__ */React8.createElement(ActivityGridItem, {
    data: data
  }) : /* @__PURE__ */React8.createElement(ActivityCarouselItem, {
    data: data
  });
};
ActivitiesByCategoriesResultActivities.fragment = fragment;
ActivitiesByCategoriesResultActivities.displayName = "ActivitiesByCategoriesResultActivities";
// src/components/activities-by-categories/activities-by-categories-category-carousel.tsx
var CategoryCarouselItem = function (param) {
  var data = param.data;
  var _data_action;
  var activities = data.activityTiles;
  var trackClick = useClickTracker4();
  return /* @__PURE__ */React9.createElement(React9.Fragment, null, /* @__PURE__ */React9.createElement(UitkSpacing6, {
    margin: {
      blockstart: "three",
      blockend: "one"
    }
  }, /* @__PURE__ */React9.createElement(UitkLayoutColumns, {
    columns: 2
  }, data.name && /* @__PURE__ */React9.createElement(UitkHeading6, {
    size: 5
  }, data.name), ((_data_action = data.action) === null || _data_action === void 0 ? void 0 : _data_action.label) && /* @__PURE__ */React9.createElement(UitkLink, {
    align: "right"
  }, /* @__PURE__ */React9.createElement("a", {
    href: data.action.url,
    target: "_blank",
    rel: "noopener noreferrer",
    onClickCapture: function () {
      var _data_action_analytics, _data_action, _data_action_analytics1, _data_action1;
      return trackClick(((_data_action = data.action) === null || _data_action === void 0 ? void 0 : (_data_action_analytics = _data_action.analytics) === null || _data_action_analytics === void 0 ? void 0 : _data_action_analytics.linkName) || "", ((_data_action1 = data.action) === null || _data_action1 === void 0 ? void 0 : (_data_action_analytics1 = _data_action1.analytics) === null || _data_action_analytics1 === void 0 ? void 0 : _data_action_analytics1.referrerId) || "");
    },
    "data-stid": "category-activity-list-see-all--carousel"
  }, data.action.label, /* @__PURE__ */React9.createElement("span", {
    className: "is-visually-hidden"
  }, data.action.accessibilityText))))), /* @__PURE__ */React9.createElement(UitkCarousel2, {
    buttonText: {
      nextButton: "",
      prevButton: ""
    },
    pageBy: 1,
    peek: true,
    itemsVisible: {
      lg: 3,
      md: 2,
      sm: 1
    }
  }, activities.map(function (activity, index) {
    return /* @__PURE__ */React9.createElement(ActivitiesByCategoriesResultActivities, {
      data: activity,
      view: "carousel",
      key: index
    });
  })));
};
// src/components/activities-by-categories/activities-by-categories-category-grid.tsx
import React10 from "react";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { UitkSecondaryButton } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex6 } from "uitk-react-layout-flex";
import { UitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading7 } from "uitk-react-text";
var CategoryGridItem = function (param) {
  var data = param.data;
  var _data_action;
  var activities = data.activityTiles;
  var trackClick = useClickTracker5();
  return /* @__PURE__ */React10.createElement(React10.Fragment, null, data.name && /* @__PURE__ */React10.createElement(UitkSpacing7, {
    margin: {
      blockstart: "three",
      blockend: "one"
    }
  }, /* @__PURE__ */React10.createElement(UitkHeading7, {
    size: 5
  }, data.name)), /* @__PURE__ */React10.createElement(UitkLayoutGrid, {
    columns: {
      small: 1,
      medium: 2,
      large: 3
    },
    tag: "ul",
    space: "three",
    alignContent: "space-between"
  }, activities.map(function (activity, index) {
    return /* @__PURE__ */React10.createElement(ActivitiesByCategoriesResultActivities, {
      data: activity,
      view: "grid",
      key: index
    });
  })), ((_data_action = data.action) === null || _data_action === void 0 ? void 0 : _data_action.label) && /* @__PURE__ */React10.createElement(UitkSpacing7, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React10.createElement(UitkLayoutFlex6, {
    justifyContent: "center"
  }, /* @__PURE__ */React10.createElement(UitkSecondaryButton, null, /* @__PURE__ */React10.createElement("a", {
    href: data.action.url,
    target: "_blank",
    rel: "noopener noreferrer",
    onClickCapture: function () {
      var _data_action_analytics, _data_action, _data_action_analytics1, _data_action1;
      return trackClick(((_data_action = data.action) === null || _data_action === void 0 ? void 0 : (_data_action_analytics = _data_action.analytics) === null || _data_action_analytics === void 0 ? void 0 : _data_action_analytics.linkName) || "", ((_data_action1 = data.action) === null || _data_action1 === void 0 ? void 0 : (_data_action_analytics1 = _data_action1.analytics) === null || _data_action_analytics1 === void 0 ? void 0 : _data_action_analytics1.referrerId) || "");
    },
    "data-stid": "category-activity-list-see-all--grid"
  }, data.action.label, /* @__PURE__ */React10.createElement("span", {
    className: "is-visually-hidden"
  }, data.action.accessibilityText))))));
};
// src/components/activities-by-categories/__private/__fragments/activities-by-categories-result-categories.tsx
var fragment2 = gql7(_templateObject6(), ActivitiesByCategoriesResultActivities.fragment);
var ActivitiesByCategoriesResultCategories = function (props) {
  var data = props.data,
    view = props.view;
  if (!data) {
    return null;
  }
  return /* @__PURE__ */React11.createElement("div", {
    "data-stid": "categories"
  }, view === "grid" ? /* @__PURE__ */React11.createElement(CategoryGridItem, {
    data: data
  }) : /* @__PURE__ */React11.createElement(CategoryCarouselItem, {
    data: data
  }));
};
ActivitiesByCategoriesResultCategories.fragment = fragment2;
ActivitiesByCategoriesResultCategories.displayName = "ActivitiesByCategoriesResultCategories";
// src/components/activities-by-categories/activities-by-categories.tsx
var __Query2 = gql8(_templateObject7(), ActivitiesByCategoriesResultCategories.fragment);
var ActivitiesByCategories = function (props) {
  var inputs = props.inputs,
    skipSsr = props.skipSsr,
    title = props.title,
    view = props.view;
  var context = useBexApi2().context;
  var trackClick = useClickTracker6();
  var variables = _object_spread_props(_object_spread({}, inputs || {}), {
    context: context
  });
  var _useQuery2 = useQuery2(__Query2, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery2.data,
    error = _useQuery2.error,
    loading = _useQuery2.loading;
  if (loading || error || !data) {
    return null;
  }
  var categories = data.activityModules.activitiesByCategories.groups;
  var moduleAction = data.activityModules.activitiesByCategories.action;
  var seoStructuredData = data.activityModules.activitiesByCategories.seoStructuredData;
  if (!categories.length) {
    return null;
  }
  return /* @__PURE__ */React12.createElement(React12.Fragment, null, title && /* @__PURE__ */React12.createElement(UitkSpacing8, {
    margin: {
      blockend: "four"
    }
  }, /* @__PURE__ */React12.createElement(UitkHeading8, {
    tag: "h3",
    size: 4
  }, title)), categories.map(function (category, index) {
    return /* @__PURE__ */React12.createElement(ActivitiesByCategoriesResultCategories, {
      data: category,
      view: view,
      key: index
    });
  }), moduleAction && /* @__PURE__ */React12.createElement(UitkSpacing8, {
    margin: {
      blockstart: "three",
      blockend: "one"
    }
  }, /* @__PURE__ */React12.createElement(UitkLayoutFlex7, {
    justifyContent: "center"
  }, /* @__PURE__ */React12.createElement(UitkSecondaryButton2, {
    role: "link"
  }, /* @__PURE__ */React12.createElement("a", {
    href: moduleAction.url,
    target: "_blank",
    rel: "noopener noreferrer",
    onClickCapture: function () {
      var _moduleAction_analytics, _moduleAction_analytics1;
      return trackClick(((_moduleAction_analytics = moduleAction.analytics) === null || _moduleAction_analytics === void 0 ? void 0 : _moduleAction_analytics.linkName) || "", ((_moduleAction_analytics1 = moduleAction.analytics) === null || _moduleAction_analytics1 === void 0 ? void 0 : _moduleAction_analytics1.referrerId) || "");
    },
    "data-stid": "category-see-all"
  }, moduleAction.label, /* @__PURE__ */React12.createElement("span", {
    className: "is-visually-hidden"
  }, moduleAction.accessibilityText))))), seoStructuredData && /* @__PURE__ */React12.createElement("script", {
    "data-stid": "activities-by-categories-structured-data",
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: seoStructuredData
    }
  }));
};
ActivitiesByCategories.displayName = "sharedui-ActivitiesByCategories";
// src/components/activities-by-poi/activities-by-poi.tsx
import React15 from "react";
import { gql as gql11, useQuery as useQuery3 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading10 } from "uitk-react-text";
// src/components/activities-by-poi/__private/__fragments/activities-by-poi-result.tsx
import React14 from "react";
import { gql as gql10 } from "@apollo/client";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { UitkSecondaryButton as UitkSecondaryButton3 } from "uitk-react-button";
import { UitkCarousel as UitkCarousel3 } from "uitk-react-carousel";
import { UitkLayoutFlex as UitkLayoutFlex8 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
// src/components/activities-by-poi/__private/__fragments/poi-details.tsx
import React13 from "react";
import { gql as gql9 } from "@apollo/client";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard5 } from "uitk-react-cards";
import { UitkFigure as UitkFigure5, UitkFigureAspectRatioType as UitkFigureAspectRatioType5, UitkImage as UitkImage5 } from "uitk-react-images";
import { UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid2 } from "uitk-react-layout-grid";
import { UitkLayoutPosition as UitkLayoutPosition4 } from "uitk-react-layout-position";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading9, UitkText as UitkText5 } from "uitk-react-text";
var fragment3 = gql9(_templateObject8());
var PoiDetails = function (props) {
  var _data_detailsLink_clickAction, _data_detailsLink, _data_detailsLink1, _data_medias_, _data_description, _data_detailsLink2, _poiAction, _poiAction1, _data_detailsLink3, _topImage, _topImage1;
  var data = props.data,
    position = props.position;
  var poiAction = ((_data_detailsLink = data.detailsLink) === null || _data_detailsLink === void 0 ? void 0 : (_data_detailsLink_clickAction = _data_detailsLink.clickAction) === null || _data_detailsLink_clickAction === void 0 ? void 0 : _data_detailsLink_clickAction.__typename) === "ActivityLinkClickAction" ? (_data_detailsLink1 = data.detailsLink) === null || _data_detailsLink1 === void 0 ? void 0 : _data_detailsLink1.clickAction : null;
  var topImage = ((_data_medias_ = data.medias[0]) === null || _data_medias_ === void 0 ? void 0 : _data_medias_.__typename) === "Image" ? data.medias[0] : null;
  var trackClick = useClickTracker7();
  var poiDescription = (_data_description = data.description) === null || _data_description === void 0 ? void 0 : _data_description.split("\n");
  var ariaLabel = "".concat((_data_detailsLink2 = data.detailsLink) === null || _data_detailsLink2 === void 0 ? void 0 : _data_detailsLink2.text, " ").concat(data.title, " ").concat((_poiAction = poiAction) === null || _poiAction === void 0 ? void 0 : _poiAction.accessibilityText);
  return /* @__PURE__ */React13.createElement(UitkSpacing9, {
    margin: {
      blockstart: "one",
      blockend: "two"
    }
  }, /* @__PURE__ */React13.createElement(UitkCard5, {
    className: "uitk-layout-flex-row"
  }, /* @__PURE__ */React13.createElement(UitkLayoutGrid2, {
    columns: {
      small: 1,
      medium: 2
    }
  }, /* @__PURE__ */React13.createElement(UitkSpacing9, {
    padding: {
      block: "three",
      inline: "three"
    }
  }, /* @__PURE__ */React13.createElement(UitkLayoutFlexItem5, {
    minWidth: "half_width"
  }, /* @__PURE__ */React13.createElement("div", null, /* @__PURE__ */React13.createElement(UitkHeading9, {
    tag: "h3",
    size: 5
  }, "".concat(position, ". ").concat(data.title)), /* @__PURE__ */React13.createElement(UitkText5, {
    size: 300,
    spacing: "three"
  }, poiDescription.length > 0 && poiDescription[0]), ((_poiAction1 = poiAction) === null || _poiAction1 === void 0 ? void 0 : _poiAction1.anchorTagUrl) && /* @__PURE__ */React13.createElement(UitkSpacing9, {
    margin: {
      block: "three",
      inline: "three"
    }
  }, /* @__PURE__ */React13.createElement(UitkLink2, {
    inline: true,
    onClickCapture: function () {
      var _poiAction_analytics, _poiAction_analytics1;
      return trackClick(((_poiAction_analytics = poiAction.analytics) === null || _poiAction_analytics === void 0 ? void 0 : _poiAction_analytics.linkName) || "", ((_poiAction_analytics1 = poiAction.analytics) === null || _poiAction_analytics1 === void 0 ? void 0 : _poiAction_analytics1.referrerId) || "");
    }
  }, /* @__PURE__ */React13.createElement("a", {
    href: poiAction.anchorTagUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    "data-stid": "poi-detail",
    "aria-label": ariaLabel
  }, /* @__PURE__ */React13.createElement(UitkText5, {
    size: 300,
    weight: "regular"
  }, (_data_detailsLink3 = data.detailsLink) === null || _data_detailsLink3 === void 0 ? void 0 : _data_detailsLink3.text))))))), /* @__PURE__ */React13.createElement(UitkLayoutFlexItem5, {
    minWidth: "half_width"
  }, /* @__PURE__ */React13.createElement(UitkLayoutPosition4, {
    type: "relative"
  }, /* @__PURE__ */React13.createElement(UitkFigure5, {
    className: "uitk-card-roundcorner-all",
    ratio: UitkFigureAspectRatioType5.R16_9
  }, /* @__PURE__ */React13.createElement(UitkImage5, {
    alt: (_topImage = topImage) === null || _topImage === void 0 ? void 0 : _topImage.description,
    placeholderImage: true,
    src: (_topImage1 = topImage) === null || _topImage1 === void 0 ? void 0 : _topImage1.url
  })))))));
};
PoiDetails.fragment = fragment3;
PoiDetails.displayName = "ActivitiesByPoiResult";
// src/components/activities-by-poi/__private/__fragments/activities-by-poi-result.tsx
var fragment4 = gql10(_templateObject9(), PoiDetails.fragment, ActivitiesByCategoriesResultCategories.fragment);
var ActivitiesByPoiResult = function (props) {
  var _data_activitiesGroup, _data_activitiesGroup1, _activitiesTiles;
  var data = props.data,
    position = props.position;
  var activityCarouselAction = (_data_activitiesGroup = data.activitiesGroup) === null || _data_activitiesGroup === void 0 ? void 0 : _data_activitiesGroup.action;
  var poi = data.poiTile;
  var activitiesTiles = (_data_activitiesGroup1 = data.activitiesGroup) === null || _data_activitiesGroup1 === void 0 ? void 0 : _data_activitiesGroup1.activityTiles;
  var trackClick = useClickTracker8();
  return /* @__PURE__ */React14.createElement(React14.Fragment, null, poi.__typename === "ActivityPoiTile" && /* @__PURE__ */React14.createElement(PoiDetails, {
    data: poi,
    position: position
  }), /* @__PURE__ */React14.createElement(UitkSpacing10, {
    margin: {
      blockstart: "one",
      blockend: "two"
    }
  }, /* @__PURE__ */React14.createElement(UitkCarousel3, {
    buttonText: {
      nextButton: "",
      prevButton: ""
    },
    pageBy: 1,
    peek: true,
    itemsVisible: {
      lg: 2.5,
      md: 2,
      sm: 1
    },
    wrapItems: false
  }, (_activitiesTiles = activitiesTiles) === null || _activitiesTiles === void 0 ? void 0 : _activitiesTiles.map(function (activity, index) {
    return /* @__PURE__ */React14.createElement(ActivitiesByCategoriesResultActivities, {
      data: activity,
      view: "carousel",
      key: index
    });
  }))), activitiesTiles && activitiesTiles.length > 0 && activityCarouselAction && /* @__PURE__ */React14.createElement(UitkSpacing10, {
    margin: {
      blockstart: "one",
      blockend: "six"
    }
  }, /* @__PURE__ */React14.createElement(UitkLayoutFlex8, {
    justifyContent: "center"
  }, /* @__PURE__ */React14.createElement(UitkSecondaryButton3, null, /* @__PURE__ */React14.createElement("a", {
    href: activityCarouselAction.url,
    target: "_blank",
    rel: "noopener noreferrer",
    onClickCapture: function () {
      var _activityCarouselAction_analytics, _activityCarouselAction_analytics1;
      return trackClick(((_activityCarouselAction_analytics = activityCarouselAction.analytics) === null || _activityCarouselAction_analytics === void 0 ? void 0 : _activityCarouselAction_analytics.linkName) || "", ((_activityCarouselAction_analytics1 = activityCarouselAction.analytics) === null || _activityCarouselAction_analytics1 === void 0 ? void 0 : _activityCarouselAction_analytics1.referrerId) || "");
    },
    "data-stid": "poi-see-all"
  }, activityCarouselAction.label)))));
};
ActivitiesByPoiResult.fragment = fragment4;
ActivitiesByPoiResult.displayName = "ActivitiesByPoiResult";
// src/components/activities-by-poi/activities-by-poi.tsx
var __Query3 = gql11(_templateObject10(), ActivitiesByPoiResult.fragment);
var ActivitiesByPoi = function (props) {
  var _data_activityModules_activityItemsByPoi, _poiList, _poiList1;
  var inputs = props.inputs,
    skipSsr = props.skipSsr,
    title = props.title;
  var context = useBexApi3().context;
  var variables = _object_spread_props(_object_spread({}, inputs || {}), {
    context: context
  });
  var _useQuery3 = useQuery3(__Query3, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery3.data,
    error = _useQuery3.error,
    loading = _useQuery3.loading;
  if (loading || error || !data) {
    return null;
  }
  var poiList = (_data_activityModules_activityItemsByPoi = data.activityModules.activityItemsByPoi) === null || _data_activityModules_activityItemsByPoi === void 0 ? void 0 : _data_activityModules_activityItemsByPoi.groups;
  if (!((_poiList = poiList) === null || _poiList === void 0 ? void 0 : _poiList.length)) {
    return null;
  }
  return /* @__PURE__ */React15.createElement(React15.Fragment, null, /* @__PURE__ */React15.createElement(UitkSpacing11, {
    margin: {
      block: "four"
    }
  }, /* @__PURE__ */React15.createElement(UitkHeading10, {
    tag: "h2",
    size: 4
  }, title)), (_poiList1 = poiList) === null || _poiList1 === void 0 ? void 0 : _poiList1.map(function (poi, index) {
    return /* @__PURE__ */React15.createElement(ActivitiesByPoiResult, {
      key: index,
      data: poi,
      position: index + 1
    });
  }));
};
ActivitiesByPoi.displayName = "sharedui-ActivitiesByPoi";
export { ActivitiesByCategories, ActivitiesByPoi, ActivityRecommendations, ActivitySearchViewOptions };